import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import { ORG } from '../../data/costant'

export default function TermsUse() {
  return (
    <FrontendLayout>
      <Hero title="Terms of Use services" />
      <div className="container my-5 card">
        <div className="card-body">
          <h6>TERMS OF USE</h6>
          <p>“{ORG.web} ({ORG.name})” is owned by {ORG.web} ({ORG.name}). The following terms and conditions govern the use of the website and (whether through a computer, mobile phone or other electronic devices), and include all sections, information, recommendations, and other products and services available on or through the website.
          </p>

          <p>
            By viewing or using the website <a href={ORG.website}>www.{ORG.web}</a>, you acknowledge that you have read and understood these customer terms (these “customer terms”). Please ensure that you read and understand all of these customer terms before you start using the website, as you will be bound by these customer terms. By accessing or using the Web Site, you and the entity you are authorized to represent ("You" Or "Your") signify your agreement to be bound by the “Terms of Use”.
          </p>

          <ul>
            <li>If you do not agree with any of these customer terms, you must immediately cease accessing and using the website and the services being provided thereunder.</li>
            <li>Your acceptance of these customer terms will operate as a binding agreement between you and {ORG.web} ({ORG.name}) in respect of your use of the website and services.</li>
          </ul>

          <h6>PARTIES</h6>
          <p>These Customer Terms are between you and/or the entity you are authorized to represent (hereinafter referred to as “customer”) and {ORG.web} ({ORG.name}). By accepting the terms, you signify your agreement to be bound by these “Terms of Use”.</p>

          <h6>SCOPE OF TERM6 OF USE</h6>
          <ul>
            <li>These Terms of Use govern the customer’s use of the website, software, and services (collectively, "Services") available via the website, except to the extent such Services are the subject of a separate agreement.</li>
            <li>Specific terms or agreements may apply to the use of certain Services and other items provided to the customer via the website ("Service Agreement(s)").</li>
          </ul>

          <h6>USER ELIGIBILITY</h6>
          <ul>
            <li>The Website is not available to minors. Customers represent that they are of legal age to form a binding contract and are not barred from viewing the website under applicable statutory laws.</li>
            <li>The customer must provide {ORG.web} with accurate, complete, and true Registration Data and can only open one Account using their own registration data.</li>
            <li>Only use the website for personal use and in accordance with these Customer Terms and all Applicable Laws.</li>
            <li>Do not use the website for any illegal or unlawful purposes.</li>
            <li>Posting any defamatory or abusive language on the website is prohibited.</li>
            <li>{ORG.web} reserves the right to refuse or terminate access to the website and any services at any time without providing a reason.</li>
          </ul>

          <h6>PAYMENTS</h6>
          <ul>
            <li>Charges for the services will be inclusive of applicable taxes where required by law.</li>
            <li>{ORG.web} will not be responsible for any loss or damage arising from payment issues such as lack of authorization, exceeding preset limits, or transaction declines.</li>
            <li>All payments must be made in Indian Rupees.
              <ul>
                <li><strong>{ORG.web} Wallet:</strong>
                  <ul>
                    <li>The Wallet allows you to load a rupee value to access Services available on the platform.</li>
                    <li>The Wallet value is not insured or guaranteed.</li>
                    <li>Credits are non-transferable, non-cancellable, and expire after 365 days of inactivity.</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>

          <h6>MODIFICATION</h6>
          <ul>
            <li>{ORG.web} may amend, revise, and update these terms of use at any time.</li>
            <li>Your continued use of the website signifies acceptance of these changes.</li>
          </ul>

          <h6>PRIVACY POLICY</h6>
            <ul>
              <li>{ORG.web}’s Privacy Policy governs the use of information collected from or provided by the customer.</li>
              <li>Customers must ensure they have obtained permissions for processing any personal information provided to {ORG.web}.</li>
            </ul>

            <h6>LICENSE AND OWNERSHI6</h6>
            <ul>
              <li>All content on the website is owned and controlled by {ORG.web} and is protected by intellectual property laws.</li>
              <li>Customers are granted a limited license to use the website as per these terms.</li>
            </ul>

            <h6>TERMINATION</h6>
            <ul>
              <li>{ORG.web} may terminate or suspend customer’s use of the website at any time and for any reason.</li>
              <li>Customers must discontinue use and destroy any content upon termination.</li>
            </ul>

            <h6>DISPUTE RESOLUTION</h6>
            <ul>
              <li>Conflicts will be resolved as per the Arbitration and Conciliation Act, 1966.</li>
              <li>Arbitration will be conducted in New Delhi, and the decision will be binding on both parties.</li>
            </ul>

            <h6>JURISDICTION</h6>
            <ul>
              <li>These terms shall be governed by the laws of India, and any proceedings will be instituted in courts in Delhi.</li>
            </ul>

            <h6>SEVERABILITY</h6>
            <ul>
              <li>If any provision is deemed invalid, the remaining provisions will remain in full force and effect.</li>
            </ul>

            <h6>WAIVER</h6>
            <ul>
              <li>Failure to enforce any provision does not constitute a waiver of that provision.</li>
            </ul>

            <h6>DISCLAIMERS</h6>
            <ul>
              <li>{ORG.web} makes no representation about the quality or usefulness of goods/services offered by third parties.</li>
              <li>Misuse of any intellectual property is strictly prohibited.</li>
            </ul>
          </div>
      </div>
    </FrontendLayout>
  )
}
